import React, { useState } from 'react';

const SECOES = [
  {
    key: 'visao',
    icon: '🗺️',
    titulo: 'Visão geral do sistema',
    resumo: 'O que é e para que serve cada aba',
    conteudo: [
      {
        tipo: 'texto',
        texto: 'O sistema Marmitas Fit foi feito para você ter controle total do seu negócio: do custo de cada marmita até o lucro no final do mês. Tudo em um só lugar, no celular.',
      },
      {
        tipo: 'lista',
        itens: [
          { icon: '🏠', titulo: 'Início', desc: 'Painel com resumo do mês: receita, lucro, custos e estoque. Ponto de partida todo dia.' },
          { icon: '🛒', titulo: 'Vender', desc: 'Registre pedidos rápido. Selecione os produtos e finalize — o estoque baixa automaticamente.' },
          { icon: '📦', titulo: 'Estoque', desc: 'Cadastre produtos, controle quantidades e veja o histórico de entradas e saídas.' },
          { icon: '📝', titulo: 'Receitas', desc: 'Cadastre a ficha técnica de cada marmita com ingredientes. O sistema calcula o custo e sugere o preço de venda.' },
          { icon: '💰', titulo: 'Financeiro', desc: 'Controle mensal completo: gastos, contas fixas, precificação e relatórios de período.' },
        ],
      },
    ],
  },
  {
    key: 'lucro',
    icon: '📈',
    titulo: 'Como ter controle do lucro',
    resumo: 'Passo a passo para saber se você está ganhando dinheiro',
    destaque: true,
    conteudo: [
      {
        tipo: 'texto',
        texto: 'Lucro = Faturamento − Gastos. Para enxergar isso com clareza, siga estes 4 passos:',
      },
      {
        tipo: 'passos',
        itens: [
          {
            num: '1',
            titulo: 'Cadastre seus insumos',
            desc: 'Em Receitas → Insumos, coloque cada ingrediente com o preço que você pagou e o peso do pacote. O sistema calcula o custo por grama automaticamente.',
            aba: 'Receitas',
          },
          {
            num: '2',
            titulo: 'Monte a ficha técnica',
            desc: 'Em Receitas → Nova Receita, adicione cada ingrediente e quanto usa por marmita. O sistema te mostra o custo real de cada unidade produzida.',
            aba: 'Receitas',
          },
          {
            num: '3',
            titulo: 'Configure a precificação',
            desc: 'Em Financeiro → Precificação, informe seu salário desejado, horas de trabalho e despesas fixas. O sistema sugere o preço mínimo para você não trabalhar no prejuízo.',
            aba: 'Financeiro → Precificação',
          },
          {
            num: '4',
            titulo: 'Acompanhe mês a mês',
            desc: 'Em Financeiro → Mês, veja o resumo: faturamento, gastos por tipo e lucro. Consulte toda sexta-feira para ajustar o que for necessário.',
            aba: 'Financeiro → Mês',
          },
        ],
      },
      {
        tipo: 'alerta',
        cor: 'var(--g)',
        corFundo: 'var(--g4)',
        icon: '💡',
        texto: 'Dica: se o lucro estiver negativo ou muito baixo, primeiro verifique se todos os gastos foram lançados em Financeiro → Gastos. Muita gente "perde" dinheiro que não registrou.',
      },
    ],
  },
  {
    key: 'vender',
    icon: '🛒',
    titulo: 'Como registrar uma venda',
    resumo: 'Rápido e sem erro',
    conteudo: [
      {
        tipo: 'passos',
        itens: [
          { num: '1', titulo: 'Abra a aba Vender', desc: 'Toque em 🛒 Vender no menu.' },
          { num: '2', titulo: 'Selecione os produtos', desc: 'Toque no produto para adicionar ao carrinho. Toque novamente para aumentar a quantidade. Use − para remover.' },
          { num: '3', titulo: 'Vincule um cliente (opcional)', desc: 'Se quiser rastrear quem comprou, selecione o cliente ou cadastre um novo ali mesmo.' },
          { num: '4', titulo: 'Finalize', desc: 'Toque em "Finalizar Pedido". O estoque já é baixado automaticamente.' },
        ],
      },
      {
        tipo: 'alerta',
        cor: 'var(--y)',
        corFundo: 'var(--y3,#fefce8)',
        icon: '⚠️',
        texto: 'Se um produto aparece cinza, é porque o estoque chegou a zero. Vá em Estoque → Produtos e registre uma entrada antes de vender.',
      },
    ],
  },
  {
    key: 'estoque',
    icon: '📦',
    titulo: 'Como gerenciar o estoque',
    resumo: 'Produtos, entradas e histórico',
    conteudo: [
      {
        tipo: 'subtitulo',
        texto: 'Cadastrar um produto',
      },
      {
        tipo: 'passos',
        itens: [
          { num: '1', titulo: 'Vá em Estoque → Produtos', desc: 'Toque em "+ Novo produto".' },
          { num: '2', titulo: 'Preencha nome e preço de venda', desc: 'O preço de venda é o que o cliente paga. Você pode preencher o custo também se não usar Receitas.' },
          { num: '3', titulo: 'Salve', desc: 'O produto aparece na lista. O estoque começa em zero.' },
        ],
      },
      {
        tipo: 'subtitulo',
        texto: 'Dar entrada no estoque',
      },
      {
        tipo: 'texto',
        texto: 'Toda vez que você produzir marmitas, registre uma entrada: abra o produto e toque em "Entrada". Informe quantas unidades foram produzidas.',
      },
      {
        tipo: 'alerta',
        cor: 'var(--b)',
        corFundo: 'var(--b3,#eff6ff)',
        icon: 'ℹ️',
        texto: 'O histórico (Estoque → Histórico) guarda todas as entradas e saídas com data e valor. Útil para conferir o que aconteceu em qualquer dia.',
      },
    ],
  },
  {
    key: 'receitas',
    icon: '📝',
    titulo: 'Como usar Receitas e Ficha Técnica',
    resumo: 'Calcule o custo real de cada marmita',
    conteudo: [
      {
        tipo: 'texto',
        texto: 'A ficha técnica é o coração do controle financeiro. Sem ela, você não sabe o custo real do que produz.',
      },
      {
        tipo: 'subtitulo',
        texto: '1. Cadastre os insumos primeiro',
      },
      {
        tipo: 'texto',
        texto: 'Em Receitas → Insumos, cadastre cada ingrediente que usa. Informe o preço pago e o peso do pacote (ex: farinha de aveia — R$ 12,90 / 500g). O sistema calcula R$/grama automaticamente.',
      },
      {
        tipo: 'subtitulo',
        texto: '2. Crie a receita',
      },
      {
        tipo: 'texto',
        texto: 'Em Receitas, toque em "+ Nova Receita". Dê o nome (ex: "Marmita Frango Grelhado"), vincule ao produto de estoque, e adicione cada ingrediente com a quantidade usada por marmita.',
      },
      {
        tipo: 'subtitulo',
        texto: '3. Leia os resultados',
      },
      {
        tipo: 'lista',
        itens: [
          { icon: '🟢', titulo: 'Custo por unidade', desc: 'Quanto você gasta em ingredientes para fazer uma marmita.' },
          { icon: '🔵', titulo: 'Preço sugerido', desc: 'Preço calculado somando ingredientes + mão de obra + despesas fixas + margem de lucro.' },
          { icon: '📊', titulo: 'Margem', desc: 'Percentual de lucro. Abaixo de 30% vale revisar ou o custo ou o preço de venda.' },
        ],
      },
    ],
  },
  {
    key: 'financeiro',
    icon: '💰',
    titulo: 'Como usar o Financeiro',
    resumo: 'Controle completo de entradas e saídas',
    conteudo: [
      {
        tipo: 'lista',
        itens: [
          {
            icon: '📅',
            titulo: 'Mês',
            desc: 'Resumo do mês selecionado: faturamento (vendas), total de gastos e lucro. Navegue entre meses com ‹ ›. Monitore aqui semanalmente.',
          },
          {
            icon: '🧾',
            titulo: 'Gastos',
            desc: 'Registre qualquer saída de dinheiro: gás, embalagem, ingredientes comprados à parte, etc. Escolha a categoria certa para o relatório ficar preciso.',
          },
          {
            icon: '🏠',
            titulo: 'Contas Fixas',
            desc: 'Cadastre contas que se repetem todo mês: aluguel, energia, internet, MEI. Configure o dia do vencimento e receba alertas de atraso no painel mensal.',
          },
          {
            icon: '⚙️',
            titulo: 'Precificação',
            desc: 'Informe seu salário desejado, dias e horas trabalhados por mês. O sistema divide o custo por minuto e aplica na ficha técnica para sugerir preços justos.',
          },
          {
            icon: '📊',
            titulo: 'Relatórios',
            desc: 'Veja o resultado de qualquer período: total de pedidos, margem por produto, entradas de estoque e despesas. Ótimo para ver a evolução do negócio.',
          },
        ],
      },
      {
        tipo: 'alerta',
        cor: 'var(--r)',
        corFundo: 'var(--r3,#fef2f2)',
        icon: '🔴',
        texto: 'Fique de olho nas contas marcadas com ⚠️ (atrasada) ou ⏰ (vencendo em 3 dias) no painel do Mês. Pagar em dia evita multa e mantém o caixa previsível.',
      },
    ],
  },
  {
    key: 'dicas',
    icon: '✨',
    titulo: 'Dicas para um negócio lucrativo',
    resumo: 'Boas práticas de quem usa o sistema direto',
    conteudo: [
      {
        tipo: 'lista',
        itens: [
          { icon: '📆', titulo: 'Toda sexta-feira', desc: 'Confira o painel Financeiro → Mês. Se os gastos já passaram de 70% da receita, freie antes que o mês feche no vermelho.' },
          { icon: '🏷️', titulo: 'Atualize os preços dos insumos', desc: 'Sempre que comprar um ingrediente com preço diferente, atualize o insumo. Isso mantém a ficha técnica precisa.' },
          { icon: '🎯', titulo: 'Margem mínima de 30%', desc: 'Abaixo de 30% de margem líquida (já com gastos fixos), o negócio não sustenta crescimento nem imprevistos.' },
          { icon: '🧾', titulo: 'Lance todo gasto na hora', desc: 'Não deixe acumular. Um gasto não lançado é dinheiro "sumido" — o lucro aparece inflado e você toma decisões erradas.' },
          { icon: '📸', titulo: 'Foto da nota fiscal', desc: 'Tire foto de toda compra. Mesmo sem integração, ter o histórico em papel ajuda a conferir se o sistema bate com o banco.' },
          { icon: '📊', titulo: 'Compare mês a mês', desc: 'Use Relatórios para comparar períodos. Se um mês foi ruim, veja o que mudou: aumento de custo, menos vendas ou mais gastos.' },
        ],
      },
    ],
  },
];

function Secao({ secao, aberta, onToggle }) {
  return (
    <div
      className="c"
      style={{
        marginBottom: 10,
        border: secao.destaque && aberta ? '2px solid var(--g3)' : undefined,
      }}
    >
      <button
        onClick={onToggle}
        style={{
          width: '100%',
          background: 'none',
          border: 'none',
          padding: '14px 16px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          textAlign: 'left',
        }}
      >
        <span style={{ fontSize: 24, flexShrink: 0 }}>{secao.icon}</span>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--c4)' }}>
            {secao.titulo}
            {secao.destaque && (
              <span style={{ marginLeft: 8, fontSize: 10, fontWeight: 700, color: 'var(--g)', background: 'var(--g4)', borderRadius: 6, padding: '2px 7px', verticalAlign: 'middle' }}>
                ESSENCIAL
              </span>
            )}
          </div>
          <div style={{ fontSize: 12, color: 'var(--c4)', marginTop: 2 }}>{secao.resumo}</div>
        </div>
        <span style={{ fontSize: 18, color: 'var(--c3)', flexShrink: 0, transition: 'transform .2s', transform: aberta ? 'rotate(90deg)' : 'none' }}>›</span>
      </button>

      {aberta && (
        <div style={{ padding: '0 16px 18px' }}>
          <div style={{ height: 1, background: 'var(--c4)', marginBottom: 16 }} />
          {secao.conteudo.map((bloco, i) => <Bloco key={i} bloco={bloco} />)}
        </div>
      )}
    </div>
  );
}

function Bloco({ bloco }) {
  if (bloco.tipo === 'texto') {
    return <p style={{ fontSize: 14, color: 'var(--c4)', lineHeight: 1.6, marginBottom: 14 }}>{bloco.texto}</p>;
  }

  if (bloco.tipo === 'subtitulo') {
    return <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--c4)', marginBottom: 10, marginTop: 4 }}>{bloco.texto}</div>;
  }

  if (bloco.tipo === 'lista') {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 14 }}>
        {bloco.itens.map((item, i) => (
          <div key={i} style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
            <span style={{ fontSize: 20, flexShrink: 0, marginTop: 1 }}>{item.icon}</span>
            <div>
              <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--c4)', marginBottom: 2 }}>{item.titulo}</div>
              <div style={{ fontSize: 12, color: 'var(--c4)', lineHeight: 1.5 }}>{item.desc}</div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (bloco.tipo === 'passos') {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 14 }}>
        {bloco.itens.map((item, i) => (
          <div key={i} style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
            <div style={{
              width: 28, height: 28, borderRadius: '50%', background: 'var(--b)', color: '#fff',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 13, fontWeight: 800, flexShrink: 0,
            }}>
              {item.num}
            </div>
            <div style={{ paddingTop: 3 }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--c4)', marginBottom: 2 }}>
                {item.titulo}
                {item.aba && (
                  <span style={{ marginLeft: 6, fontSize: 10, color: 'var(--b)', background: 'var(--b3,#eff6ff)', borderRadius: 5, padding: '1px 6px', fontWeight: 600 }}>
                    {item.aba}
                  </span>
                )}
              </div>
              <div style={{ fontSize: 12, color: 'var(--c4)', lineHeight: 1.5 }}>{item.desc}</div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (bloco.tipo === 'alerta') {
    return (
      <div style={{
        padding: '10px 14px',
        background: bloco.corFundo,
        borderRadius: 10,
        borderLeft: `3px solid ${bloco.cor}`,
        marginBottom: 14,
        display: 'flex',
        gap: 10,
        alignItems: 'flex-start',
      }}>
        <span style={{ fontSize: 18, flexShrink: 0 }}>{bloco.icon}</span>
        <span style={{ fontSize: 13, color: 'var(--c4)', lineHeight: 1.5 }}>{bloco.texto}</span>
      </div>
    );
  }

  return null;
}

export default function TutorialPage() {
  const [aberta, setAberta] = useState('lucro');

  const toggle = (key) => setAberta(prev => prev === key ? null : key);

  return (
    <div>
      <div className="c" style={{ padding: '14px 16px', marginBottom: 14, background: 'var(--g4)', border: '1px solid var(--g3)' }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--g)', marginBottom: 4 }}>📚 Guia do sistema</div>
        <div style={{ fontSize: 13, color: 'var(--c4)', lineHeight: 1.5 }}>
          Toque em qualquer seção para expandir. Comece pela <strong>marcada como Essencial</strong> se quiser entender como ter controle do lucro.
        </div>
      </div>

      {SECOES.map(s => (
        <Secao
          key={s.key}
          secao={s}
          aberta={aberta === s.key}
          onToggle={() => toggle(s.key)}
        />
      ))}

      <div style={{ textAlign: 'center', padding: '20px 0 8px', fontSize: 12, color: 'var(--c3)' }}>
        Marmitas Fit · Controle financeiro para produtoras de refeições
      </div>
    </div>
  );
}
